/**
 * Users / Cohort segmented control for the Orientation Assignment
 * target picker (COHORT-SCHEDULING-PLAN Phase 4: "its target picker
 * gains a Cohort option next to users").
 */
export type AssignTarget = 'users' | 'cohort';

export function TargetToggle({
  value,
  onChange,
}: {
  value: AssignTarget;
  onChange: (v: AssignTarget) => void;
}) {
  return (
    <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
      <span style={{ fontSize: 11, color: 'var(--muted)' }}>Assign to</span>
      {(
        [
          { v: 'users' as const, label: 'Users' },
          { v: 'cohort' as const, label: 'Cohort' },
        ]
      ).map((opt) => (
        <button
          key={opt.v}
          type="button"
          className={'chip-filter ' + (value === opt.v ? 'on' : '')}
          onClick={() => onChange(opt.v)}
          aria-pressed={value === opt.v}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
